import { type CreditUsageStats } from '~/components/CreditUsageMeter/types';

export const getAllowCreditOverage = (creditStats: CreditUsageStats | undefined): boolean =>
  creditStats?.allowCreditOverage === true;
